<div class="d-flex flex-column h-100" data-cy="collage-template-container">
  <h3 style="text-align: center" data-cy="collage-template-title">Please select a template</h3>
  <div class="bg-light justify-content-center" fxLayout="row wrap" fxLayoutGap="grid" style="height: 90%;
  display: flex; overflow: scroll" data-cy="collage-template-grid">
    <mat-card appearance="outlined" fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="20%" class="template-tile" disabled (click)="openNameDialog()" data-cy="collage-template-new-card">
      <i class="material-icons" data-cy="collage-template-add-icon">add_circle</i>  Save Current as Template
    </mat-card>
    @for (template of templates; track template) {
      <mat-card appearance="outlined" fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="20%" class="template-tile" (click)="selectTemplate(template)" data-cy="collage-template-item">
        @if (selectedTemplate === template) {
          <div class="selected-check" data-cy="collage-template-selected-check">
            <lucide-icon name="check-circle" [size]="20" class="text-success" data-cy="collage-template-check-icon"></lucide-icon>
          </div>
        }
        <mat-card-content (click)="selectTemplate(template)" data-cy="collage-template-content">
          @if (template?.TemplateSVGIcon !== null || template?.TemplateSVGIcon !== undefined) {
            <img
              class="template-img" [src]="template?.TemplateSVGIcon" width="100%" height="auto" data-cy="collage-template-icon" />
          }
          @if (template?.TemplateSVGIcon === null || template?.TemplateSVGIcon === undefined) {
            <img
              class="template-img" src="assets/icons/not-found.svg" width="100%" height="auto" style="padding:20%" data-cy="collage-template-default-icon" />
          }
          <mat-divider inset data-cy="collage-template-divider"></mat-divider>
          <div class="template-label" data-cy="collage-template-name">{{template?.TemplateName}}</div>
        </mat-card-content>
      </mat-card>
    }

  </div>

  <div class="d-flex justify-content-end mt-auto" data-cy="collage-template-actions">
    <div class="mr-auto" data-cy="collage-template-options">
      @if (templates.length > 0) {
        <mat-checkbox (change)="hasMargin = $event.checked" data-cy="collage-template-margin-checkbox">Margins</mat-checkbox>
      }
    </div>

    <div data-cy="collage-template-buttons">
      <button mat-button class="tdox-btn tdox-btn-primary-d mr-2" (click)="cancel()"
        style="width: 125px" data-cy="collage-template-cancel-button">
        Cancel
      </button>
      <button mat-button class="tdox-btn tdox-btn-primary" (click)="applyTemplate()"
        style="width: 125px" data-cy="collage-template-apply-button">
        Apply
      </button>
    </div>
  </div>
</div>


